import { CourseEditorTypeEnum, CourseId } from '../types/course-interface'

export interface GetCourseSettingsUrlProps {
  courseId: CourseId
  courseType?: CourseEditorTypeEnum
}

export const getCourseSettingsUrl = ({ courseId, courseType }: GetCourseSettingsUrlProps) =>
  courseType === CourseEditorTypeEnum.LightCourse
    ? `/courses/light-course/${courseId}/settings`
    : `/courses/${courseId}`
